import {SearchResponse} from "../../../objects/responses/searchResponse";
import {Injectable} from "@angular/core";
import {CustomerService} from "../../../services/customerService";
import {CustomerSearchRequest} from "../../../objects/requests/customerSearchRequest";
import {Customer} from "../../../objects/customers/customer";
import { OrderBy } from "ngx-odata-v4";
/**
 * Created by alex.y on 9/7/2017.
 */

@Injectable()
export class CustomerManagementResolver {

    constructor(private customerService: CustomerService) {
    }

    public resolve(): Promise<SearchResponse<Customer>> {

        return this.customerService.search(new CustomerSearchRequest({
            Skip: 0,
            Top: 12,
            Query: '',
            OrderBy: {PropertyName: 'Id', OrderBy: OrderBy.Desc},
            FillOrders: false
        })).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/customerManagement/customerManagement.resolver.ts